<script>
  export default {
    name: 'confidentialIssueWarning',
  };
</script>
<template>
  <div class="confidential-issue-warning">
    <i
    aria-hidden="true"
    class="fa fa-eye-slash">
    </i>
    <span>
      This is a confidential issue. Your comment will not be visible to the public.
    </span>
  </div>
</template>



// WEBPACK FOOTER //
// confidential_issue_warning.vue?220ff213